import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, ManagerGuard, NoAuthGuard } from './guards';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth',
        canActivate: [NoAuthGuard],
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
      },
      {
        path: 'manager',
        canActivate: [AuthGuard, ManagerGuard],
        loadChildren: () => import('./modules/manager/manager.module').then(m => m.ManagerModule)
      },
      {
        path: 'nurse',
        loadChildren: () => import('./modules/nurse/nurse.module').then(m => m.NurseModule)
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'auth'
      }
    ]
  }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
